/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundTimeBackIcon20Light = forwardRef('ArrowRoundTimeBackIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.737 3.807a7 7 0 1 1-3.22 8.834.5.5 0 0 0-.926.377A8 8 0 1 0 3 6.127V2.748a.5.5 0 0 0-1 0V7.5a.5.5 0 0 0 .5.5H7a.5.5 0 0 0 0-1H3.675a7 7 0 0 1 3.062-3.193Z" })));
});
